module.exports = __webpack_public_path__ + "img/center-guide-hero-5.23d8ad69.png";